<template>
  <div
    :class="
      showOnMobile ? 'd-block text-center d-xl-none d-lg-none' : 'd-none d-xl-block d-lg-block'
    "
  >
    <vb-button class="legend-button" :vb_options="{ variant: 'ghost' }" role="button" @click="() => toggle()"> 
      <vb-icon name="filter" :size="16"></vb-icon>
      <span>
        {{ toggled ? 'Chiudi' : 'Legenda' }}
      </span>
    </vb-button>
  </div>
</template>

<script> 
export default {
  name: 'seat-map-info-button',
  props: {
    showOnMobile: Boolean,
    toggled: Boolean,
    toggle: Function,
  }, 
};
</script>

<style lang="scss">
.legend-button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-items: center;
  justify-content: center;
  border: 1px silver solid;
  gap: 10px;
}
</style>
